import React from "react";
import { FastField, Field } from "formik";
import { DatePicker } from "../../formik-material-ui";

export default function FDatePicker({ onChange, fast, ...other }) {
  const allProps = {
    component: DatePicker,
    onChange: onChange,
    ...other,
  };

  if (fast !== false) {
    return <FastField {...allProps} />;
  }
  return <Field {...allProps} />;
}
